import React, { useEffect, useState, useRef } from "react";
import "./BackupCard.scss";

import DayPicker, { DateUtils } from "react-day-picker";
import "react-day-picker/lib/style.css";

import MessageBox from "../../assets/MessageBox/MessageBox";
import * as actionTypes from "../../store/actions/actionTypes";
import * as actions from "../../store/actions/index";
import { connect } from "react-redux";
import axios from "axios";

const Backupcard = (props) => {
  const token = localStorage.getItem("token");

  // initial state factory (kept same shape as original)
  const getInitialState = () => ({
    from: undefined,
    to: undefined,
    bck_btn: "disabled",
    selectedFileType: "csv",
    fileType: [
      { csv: "fileType current" },
      { pdf: "fileType" },
      { xls: "fileType" },
    ],
    backup_data: {},
    msgBox: {
      _class: "msg_container animated zoomOutRight",
      isavailble: "false",
      header: "",
      body: "",
    },
  });

  const [ids, setIds] = useState([]);
  const [alias, setAlias] = useState([]); // kept for parity though not used
  const [selectedId, setSelectedId] = useState("");
  const [state, setState] = useState(getInitialState());
  const [freq, setFreq] = useState("default");
  const [deviceParameters, setDeviceParameters] = useState([]);
  const [averageType, setAverageType] = useState({});
  const [isOptionVisible, setIsOptionVisible] = useState(false);

  // destructure from state for convenience
  const { from, to, fileType } = state;
  const modifiers = { start: from, end: to };

  // refs for selects (mirrors original DOM usage)
  const deviceSelectRef = useRef(null);

  // keep showMessage timeout ref to cleanup
  const msgTimeoutRef = useRef(null);

  useEffect(() => {
    // componentDidMount equivalent
    try {
      const devices = JSON.parse(localStorage.getItem("devices"));
      if (devices && Array.isArray(devices.devices)) {
        const active = devices.devices
          .filter(
            (item) =>
              item.serviceDetails && item.serviceDetails.status === "active"
          )
          .map((item) => ({
            alias: item.deviceDetails ? item.deviceDetails.alias : undefined,
            id: item.deviceDetails ? item.deviceDetails.device_id : undefined,
          }));

        setIds(active);
        setAlias(active.map((a) => a.alias));
        if (active.length > 0) {
          // set default selected id to first available (mirrors likely expected behavior)
          setSelectedId(active[0].id || "");
        }
      }
    } catch (err) {
      // if parsing fails, keep arrays empty
      console.warn("Failed to parse devices from localStorage", err);
    }

    return () => {
      // cleanup message timeout if component unmounts
      if (msgTimeoutRef.current) {
        clearTimeout(msgTimeoutRef.current);
      }
    };
    // empty deps -> run once
  }, []);

  useEffect(() => {
    let type = selectedId.replace(/[^A-Za-z]/g, "");

    console.log({ freq });

    console.log({ type });
    if (freq && freq !== "default") {
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/devices/parameters/${type}`, {
          headers: {
            "x-api-key": token,
          },
        })
        .then((response) => {
          console.log("Fetched device parameters:", response.data);
          let parameters = response.data.parameters || [];
          let visibleParaForType = JSON.parse(
            localStorage.getItem("visibleParaForType")
          );
          console.log({ visibleParaForType });
          if (visibleParaForType && visibleParaForType[type]) {
            parameters = Object.keys(parameters)
              .filter((param) =>
                visibleParaForType[type].includes(param.toLowerCase())
              )
              .map((param) => param);
            console.log({ parameters });
            setDeviceParameters(parameters);
           
          } else {
            parameters= Object.keys(parameters).map((param) => param);
            setDeviceParameters(
              parameters  
            );
          }

            let averageTypeObj = parameters.map((param) => param.includes("Totalizer")? [param,"last"] :[param, "average"]);
            let averageTypeState = Object.fromEntries(averageTypeObj);
            console.log({averageTypeState});
            setAverageType(averageTypeState);
        })
        .catch((error) => {
          console.error("Error fetching device parameters:", error);
        });
    }else{
      setDeviceParameters([]);
    }
  }, [selectedId, freq]);

  useEffect(() => {
    // componentDidUpdate equivalent
    console.log("State updated:", averageType);
  }, [averageType]);

  // Similar to componentDidUpdate watchers in original (they were debug logs)
  // If you had specific values like 'count' or 'name' in state you want to watch,
  // add separate useEffect hooks for them.

  const handleDayClick = (day) => {
    const range = DateUtils.addDayToRange(day, {
      from: state.from,
      to: state.to,
    });
    setState((prev) => ({ ...prev, ...range, bck_btn: "enabled" }));
  };

  const handleResetClick = () => {
    setState(getInitialState());
  };

  const showMessage = (msg) => {
    setState((prev) => ({
      ...prev,
      msgBox: {
        isavailble: "true",
        header: "Info!",
        body: msg,
        _class: "msg_container animated zoomInRight",
      },
    }));

    if (msgTimeoutRef.current) clearTimeout(msgTimeoutRef.current);
    msgTimeoutRef.current = setTimeout(() => {
      setState((prev) => ({
        ...prev,
        msgBox: {
          isavailble: "true",
          header: "Info!",
          body: prev.msgBox.body,
          _class: "msg_container animated zoomOutRight",
        },
      }));
    }, 4000);
  };

  const getBuckup = (method) => {
    if (!state.from || !state.to) {
      showMessage("Please select a date range.");
      return;
    }

    let _to = new Date(state.to);
    const ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(_to);
    const mo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(_to);
    const da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(_to);
    _to = ye + "-" + mo + "-" + da;

    let _from = new Date(state.from);
    const ye1 = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
      _from
    );
    const mo1 = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
      _from
    );
    const da1 = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(_from);
    _from = ye1 + "-" + mo1 + "-" + da1;

    const _id = deviceSelectRef.current
      ? deviceSelectRef.current.value
      : selectedId;
    // const _freq = freqSelectRef.current ? freqSelectRef.current.value : "default";

    if (method === actionTypes.REPORT_DOWNLOAD) {
      props.onGenerateReport(
        _id,
        _from,
        _to,
        freq,
        actionTypes.REPORT_DOWNLOAD,
        state.selectedFileType,
        averageType
      );
    } else if (method === actionTypes.REPORT_VIEW) {
      props.onGenerateReport(
        _id,
        _from,
        _to,
        freq,
        actionTypes.REPORT_VIEW,
        null,
        averageType
      );
    }
  };

  const filetypehandler = (val) => {
    // Keep the original DOM icon toggling behaviour (minimal change).
    // Ideally we'd control icons purely with state, but preserving existing behaviour.
    const csvIcon = document.getElementById("csv_icon");
    const pdfIcon = document.getElementById("pdf_icon");
    // const xlsIcon = document.getElementById("xls_icon");

    if (csvIcon) {
      csvIcon.classList.remove("fas");
      csvIcon.classList.add("fal");
    }
    if (pdfIcon) {
      pdfIcon.classList.remove("fas");
      pdfIcon.classList.add("fal");
    }
    // if (xlsIcon) {
    //   xlsIcon.classList.remove("fas");
    //   xlsIcon.classList.add("fal");
    // }

    if (val === "csv") {
      if (csvIcon) {
        csvIcon.classList.remove("fal");
        csvIcon.classList.add("fas");
      }
      setState((prev) => ({
        ...prev,
        selectedFileType: "csv",
        fileType: [
          { csv: "fileType current" },
          { pdf: "fileType" },
          { xls: "fileType" },
        ],
      }));
    } else if (val === "pdf") {
      if (pdfIcon) {
        pdfIcon.classList.remove("fal");
        pdfIcon.classList.add("fas");
      }
      setState((prev) => ({
        ...prev,
        selectedFileType: "pdf",
        fileType: [
          { csv: "fileType" },
          { pdf: "fileType current" },
          { xls: "fileType" },
        ],
      }));
    } /* else if (val === "xls") {
      if (xlsIcon) {
        xlsIcon.classList.remove("fal");
        xlsIcon.classList.add("fas");
      }
      setState((prev) => ({
        ...prev,
        selectedFileType: "xls",
        fileType: [{ csv: "fileType" }, { pdf: "fileType" }, { xls: "fileType current" }],
      }));
    } */
  };

  // Keep parity with original token-based redirect behavior
  if (
    props.error &&
    typeof props.error === "string" &&
    props.error.includes("token")
  ) {
    window.location.href = "/";
    window.location.reload();
  }

  return (
    <div className="b_Content">
      <div className="b_header">
        <h4>Backup Data</h4>
      </div>

      <div className="select-wrapper">
        <div className="deviceIdSelect__reports">
          <select
            id="deviceIdSelect__reports"
            ref={deviceSelectRef}
            value={selectedId}
            onChange={(e) => setSelectedId(e.target.value)}
          >
            {ids &&
              ids.map((item) => {
                if (item && item.id)
                  return (
                    <option value={item.id} key={`id_${item.id}`}>
                      {item.alias ? `${item.alias} (${item.id})` : `${item.id}`}
                    </option>
                  );
                else
                  return (
                    <option value={item} key={`id_${item}`}>
                      {item}
                    </option>
                  );
              })}
          </select>
        </div>
        &nbsp; &nbsp; &nbsp;
        <div className="deviceIdSelect__reports">
          <select
            id="freqSelect__reports"
            value={freq}
            onChange={(e) => setFreq(e.target.value)}
          >
            <option value="default">Default</option>
            <option value="daily">Daily</option>
            <option value="monthly">Monthly</option>
            <option value="yearly">Yearly</option>
          </select>
        </div>
      </div>

      <br />
      <div className="RangeExample">
        <p className="text_highlight">
          {!from && !to && "Please select the First Day."}
          {from && !to && "Please select the Last Day."}
          {from &&
            to &&
            `Selected from ${from.toLocaleDateString()} to ${to.toLocaleDateString()}`}
        </p>

        {from && to && (
          <p className="resetbtn" onClick={handleResetClick}>
            <i className=" fal fa-sync"></i> <span>Reset</span>
          </p>
        )}
        <br />
        <DayPicker
          className="Selectable"
          numberOfMonths={props.numberOfMonths || 2}
          selectedDays={[from, { from, to }]}
          modifiers={modifiers}
          onDayClick={handleDayClick}
        />
      </div>
      {deviceParameters?.length > 0 ? (
        <div>
          <div style={{display:"flex", alignItems:"center", justifyContent:"space-between"}}>

          <p className="info_text" style={{fontWeight:"bolder"}}>Option to choose instead of average</p>
          <button ></button>
          </div>
          <div className="parameters_list" >
            {" "}
            {deviceParameters?.map((para) => {
              return (
                <div key={para} style={{ display: "flex", alignItems: "center" }}>
                  <span className="parameter_item " style={{ padding: "10px" }}>
                    {para.toUpperCase().split("_").join(" ")}
                  </span>{" "}
                  <div className="deviceIdSelect__reports">
                    <select
                      className="parameter_select"
                      value={averageType[para] || "average"}
                      onChange={(e) => {
                        let selectedOption = e.target.value;
                        console.log({ selectedOption });
                        setAverageType((prev) => ({ ...prev, [para]: selectedOption }));
                      }}
                    >
                      <option value="average">Average Value</option>
                      <option value="max">Maximum Value</option>
                      <option value="min">Minimum Value</option>
                      <option value="last">Last Value</option>
                    </select>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ): null}
      <br />
      <div className="b_footer">
        <div className="radio_con">
          <div
            className={fileType[0].csv}
            onClick={() => filetypehandler("csv")}
          >
            <i
              style={{ fontSize: "2rem", color: "#7B83EB" }}
              id="csv_icon"
              className="fas fa-file-csv"
            ></i>
          </div>
          <div
            className={fileType[1].pdf}
            onClick={() => filetypehandler("pdf")}
          >
            <i
              style={{ fontSize: "2rem", color: "#F95248" }}
              id="pdf_icon"
              className="fal fa-file-pdf"
            ></i>
          </div>
          {/* <div className={fileType[2].xls} onClick={() => filetypehandler("xls")}>
            <i style={{ fontSize: "2rem", color: "#21bc96" }} id="xls_icon" className="fal fa-file-spreadsheet"></i>
          </div> */}
          <div className="slider"></div>
        </div>{" "}
        <div className="btn_con purple">
          {from && to && (
            <button onClick={() => getBuckup(actionTypes.REPORT_VIEW)}>
              <i className="fad fa-eye"></i>
            </button>
          )}
        </div>
        <div className="btn_con">
          {from && to && (
            <button onClick={() => getBuckup(actionTypes.REPORT_DOWNLOAD)}>
              <i className="fad fa-download"></i>
            </button>
          )}
        </div>
      </div>

      <MessageBox
        headerText={state.msgBox.header}
        bodyText={state.msgBox.body}
        _type="info"
        _class={state.msgBox._class}
      />
    </div>
  );
};

// keep mapStateToProps and mapDispatchToProps as before
const mapStateToProps = (state) => {
  return {
    loading: state.auth.loading,
    error: state.auth.error,
    reportData: state.reports.reportData,
    method: state.reports.method,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGenerateReport: (id, from, to, freq, method, fileType,averageType ) =>
      dispatch(actions.generateReport(id, from, to, freq, method, fileType, averageType)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Backupcard);
